import { INotifiedEscalatedShipmentIssueInput } from 'types/graphqlTypes'
import { IEscalatedIssuesQuery } from '../graphql/EscalatedIssues'

/**
 * Given a list of userEscalated issues (issues that are past SLA), return a list of issues
 * that have been notified/escalated to users for the first time.
 *
 * These are issues that have not been `notified` or `escalated` before (values are `false`) and are past SLA
 * times (`shouldNotify` or `shouldEscalate` are `true`).
 */
export const getFirstTimeNotifiedIssues = (
  issues: IEscalatedIssuesQuery['paginatedShipmentIssues']['nodes']
) => {
  return (
    issues?.reduce<INotifiedEscalatedShipmentIssueInput[]>((newNotifiedIssues, issue) => {
      if (!issue) return newNotifiedIssues

      const { escalated, id, notified, shouldEscalate, shouldNotify } = issue
      const shouldUpdateNotified = !notified && shouldNotify
      const shouldUpdateEscalated = !escalated && shouldEscalate

      if (!shouldUpdateEscalated && !shouldUpdateNotified) return newNotifiedIssues

      return [
        ...newNotifiedIssues,
        {
          id,
          ...(shouldUpdateNotified && { notified: true }),
          ...(shouldUpdateEscalated && { escalated: true }),
        },
      ]
    }, []) || []
  )
}
